var plugin_rtlignore_default = {
  "alignLeft": "_6CrqZ",
  "textWrapNowrap": "tUCwj",
  "alignRight": "Dvu-F",
  "alignCenter": "QOQFo",
  "sizeFullWidth": "_8EJWq",
  "renderedInTable": "aD0Rb",
  "sizeOriginal": "JGH7g",
  "sizeContent": "w2gbc",
  "sizeSmall": "_0wraz",
  "sizeSmallCenter": "QSU3k",
  "flex": "oMmbS",
  "atomic": "gm5ci",
  "anchor": "yq4zJ",
  "embed": "IB2mY",
  "horizontalScrollbar": "UoQXi",
  "pluginContainerMobile": "IxK6a"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
